import ImageSlider from "../../../FinalOutput/Components/Slider-prewedding/ImageSlider";
import PreWeddingVideo from "../../../FinalOutput/Components/Slider-prewedding/PreWeddingVideo";
 import './sliderpre.css'

const Sliderpre = ({ details }) => {
    const images = details?.footerImages || [];
    const preWeddingLink = details?.preWeddingLink?.trim();

    const hasImages = images.length > 0;
    const hasPreWedding = !!preWeddingLink;

     if (!hasImages && !hasPreWedding) {
    return null;
  }

    return (
        <section
            className={`t4-slider-section
                ${details?.theme || ''}`}
        >

            <div className={`t4-slider-content   ${hasPreWedding ? 'theme4-has-prewedding': ''}  `}   >
                {hasImages && <ImageSlider images={images} />}
                {hasPreWedding && <PreWeddingVideo link={preWeddingLink} />}
            </div>

        </section>
    );
};

export default Sliderpre;